var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-fastly"}},[_c('div',{staticClass:"pop-up"},[_c('div',{staticClass:"pop-up-shade",on:{"click":_vm.hidePopup}}),_c('div',{staticClass:"pop-up-box"},[_c('span',{staticClass:"close",on:{"click":_vm.hidePopup}}),_c('div',{staticClass:"_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }